module.exports = __webpack_public_path__ + "img/heart_rate_calculator.30da3685.jpg";